module.exports = __webpack_public_path__ + "static/img/chengzhang.76fc70b7.png";